
import urls from './urls'

export const defaultsTemplate = {
  // 代理前缀
  'baseURL': '',
  // 经销商还是....
  'isDmsEnd': false,
  // 是否已经登陆
  'requireAuth': false,
  // 应用在网关的唯一标识
  'x-app-code': '',
  // 版本
  'x-app-version': '0.0.0',
  // 用户usercode
  'x-user-code': '',
  // 用户username
  'x-user-name': '',
  // 用户所选的当前岗位代码
  'x-position-code': '',
  // smg orgCode
  'x-org-code': '',
  // sgm userInfo
  'userInfo': {},
  // 售前/售后/部分 的代码
  'x-dealer-code': '',
  // 经销商的 storeCode  仅限dealer网关和oneapp
  'x-store-code': '',
  // 经销商售后代码  仅限dealer网关和oneapp
  'x-sale-code': '',
  // 经销商售前代码  仅限dealer网关和oneapp
  'x-service-code': '',
  'x-pagesession-code': '',
  // 用户信息
  'currentPositionInfo': {},
  // 左目录
  'menu': [],
  // 接口
  'resouces': resoucesProcess(urls),
  // 接口id
  'resoucesIds': [],
  // header内容
  'htmlContent': '',
  // 多经销商
  'dealerList': {},

  'router': {},
  // XMLHttpRequest 请求
  'x-Requested-With': 'XMLHttpRequest',

  'callback': (next) => {
    next();
  }
}

export const cacheTemplate = [
  'baseURL', 
  'isDmsEnd',
  'x-app-code',
  'x-app-version',
  'x-user-code',
  'x-user-name',
  'x-position-code',
  'x-org-code',
  'userInfo',
  'x-dealer-code',
  'x-store-code',
  'x-sale-code',
  'x-service-code',
  'currentPositionInfo',
  'menu',
  'resouces',
  'resoucesIds',
  'htmlContent',
  'dealerList',
  'requireAuth',
  'x-pagesession-code',
  'x-Requested-With',
  'router'
]

export const proTemplate = [
  'baseURL', 
  'isDmsEnd',
  'x-app-code',
  'x-app-version',
  'resouces',
  'x-Requested-With',
  'router'
]

export const devTemplate = [
  'baseURL', 
  'isDmsEnd',
  'x-app-code',
  'x-app-version',
  'x-user-code',
  'x-user-name',
  'x-position-code',
  'x-org-code',
  'userInfo',
  'x-dealer-code',
  'x-store-code',
  'x-sale-code',
  'x-service-code',
  'currentPositionInfo',
  'menu',
  'resouces',
  'resoucesIds',
  'htmlContent',
  'dealerList',
  'requireAuth',
  'x-pagesession-code',
  'x-Requested-With',
  'router'
]

export const headersTemplate = [
  'x-app-code',
  'x-app-version',
  'x-user-code',
  'x-org-code',
  'x-resource-code',
  'x-track-code',
  'x-position-code',
  'x-dealer-code',
  'x-store-code',
  'x-sale-code',
  'x-service-code',
  'x-pagesession-code',
  'x-Requested-With'
]

function resoucesProcess (data) {
  if (!data) return;
  let ob = {};
  for(let k in data) {
    ob[data[k]['method']+','+data[k]['path']]= data[k];
  }
  return ob;
}
